import React from 'react';
import '../App.css';
import { useMediaQuery } from 'react-responsive';

function AboutSkills() {
  const isSmallLaptop = useMediaQuery({
    query: '(max-width: 1000px)',
  });

  return (
    <div
      style={{
        width: isSmallLaptop ? '70vw' : '800px',
        margin: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
      }}>
      <h2 style={{ color: '#9ca3af', fontWeight: '500' }}>HTML CSS</h2>
      <div
        style={{ width: '100%', backgroundColor: '#e5e7eb', height: '6px', borderRadius: '4px' }}>
        <div
          style={{
            width: '100%',
            backgroundColor: '#4f46e5',
            height: '6px',
            borderRadius: '4px',
          }}></div>
      </div>

      <h2 style={{ color: '#9ca3af', fontWeight: '500' }}>Javascript</h2>
      <div
        style={{ width: '100%', backgroundColor: '#e5e7eb', height: '6px', borderRadius: '4px' }}>
        <div
          style={{
            width: '66.6667%',
            backgroundColor: '#4f46e5',
            height: '6px',
            borderRadius: '4px',
          }}></div>
      </div>

      <h2 style={{ color: '#9ca3af', fontWeight: '500' }}>React</h2>
      <div
        style={{ width: '100%', backgroundColor: '#e5e7eb', height: '6px', borderRadius: '4px' }}>
        <div
          style={{
            width: '100%',
            backgroundColor: '#4f46e5',
            height: '6px',
            borderRadius: '4px',
          }}></div>
      </div>

      <h1 style={{ fontSize: '1.875rem', fontWeight: '500', color: 'white', marginTop: '10px' }}>
        Languages
      </h1>

      <h2 style={{ color: '#9ca3af', fontWeight: '500' }}>Armenian - Native</h2>
      <div
        style={{ width: '100%', backgroundColor: '#e5e7eb', height: '6px', borderRadius: '4px' }}>
        <div
          style={{
            width: '100%',
            backgroundColor: '#4f46e5',
            height: '6px',
            borderRadius: '4px',
          }}></div>
      </div>

      <h2 style={{ color: '#9ca3af', fontWeight: '500' }}>Georgian - B2</h2>
      <div
        style={{ width: '100%', backgroundColor: '#e5e7eb', height: '6px', borderRadius: '4px' }}>
        <div
          style={{
            width: '50%',
            backgroundColor: '#4f46e5',
            height: '6px',
            borderRadius: '4px',
          }}></div>
      </div>

      <h2 style={{ color: '#9ca3af', fontWeight: '500' }}>Russian - C2</h2>
      <div
        style={{ width: '100%', backgroundColor: '#e5e7eb', height: '6px', borderRadius: '4px' }}>
        <div
          style={{
            width: '100%',
            backgroundColor: '#4f46e5',
            height: '6px',
            borderRadius: '4px',
          }}></div>
      </div>

      <h2 style={{ color: '#9ca3af', fontWeight: '500' }}>English - B2 +</h2>
      <div
        style={{ width: '100%', backgroundColor: '#e5e7eb', height: '6px', borderRadius: '4px' }}>
        <div
          style={{
            width: '83.3333%',
            backgroundColor: '#4f46e5',
            height: '6px',
            borderRadius: '4px',
          }}></div>
      </div>
    </div>
  );
}

export default AboutSkills;
